import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalComponent } from '../modal/modal.component';

/**
 * Modal to confirm/cancel an action. Uses {@link ModalComponent} to display content.
 */
@Component({
  selector: 'ct-lib-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: true,
  imports: [ModalComponent, TranslocoPipe],
})
export class ConfirmModalComponent {
  @ViewChild('modal', {static: false}) public modal: ModalComponent;
  @Input() autoCloseOnConfirm = true;
  @Input() label: string;
  @Input() cancelLabel: string;
  @Input() confirmLabel: string;
  @Input() hideCancelButton = false;
  @Input() hideConfirmButton = false;
  @Input() disableConfirmButton = false;
  @Input() size: string;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onCloseEnd: EventEmitter<any> = new EventEmitter();
  @Output() onOpen: EventEmitter<any> = new EventEmitter();
  @Output() onOpenEnd: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();



  cancel(): void {
    this.modal.close(); // Hier wird eventuell etwas anderes gewünscht
    this.onCancel.emit();
  }

  confirm(): void {
    if (this.disableConfirmButton) return;
    if (this.autoCloseOnConfirm) this.modal.close();
    this.onConfirm.emit();
  }
}
